module.exports = __webpack_public_path__ + "img/D285DAC79ABA8003CFD1013D7A04533C.d285dac7.png";